import React__default, { useMemo } from 'react';

var ArticleLeadMedia = function ArticleLeadMedia(props) {
  var image = props.image,
    caption = props.caption,
    videoId = props.videoId,
    embedCode = props.embedCode,
    isVertical = props.isVertical,
    leadMediaGalleryContent = props.leadMediaGalleryContent;
  var embedHtml = useMemo(function () {
    return {
      __html: embedCode !== null && embedCode !== void 0 ? embedCode : ''
    };
  }, [embedCode]);
  var captionHtml = useMemo(function () {
    return {
      __html: caption !== null && caption !== void 0 ? caption : ''
    };
  }, [caption]);
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-lead-media",
    className: isVertical ? 'md:w-2/4' : undefined
  }, /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-lead-media-content",
    className: "mx-[-16px] shrink-0 lg:mx-0"
  }, image ? image : videoId ? /*#__PURE__*/React__default.createElement("div", {
    className: "relative block max-w-full"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pb-[56.25%]"
  }, /*#__PURE__*/React__default.createElement("iframe", {
    className: "absolute inset-0 size-full border-0",
    src: "https://players.brightcove.net/968289166001/3BDEJ1Vql_default/index.html?videoId=".concat(videoId),
    allowFullScreen: true,
    allow: "encrypted-media",
    sandbox: "allow-scripts"
  }))) : embedCode ? /*#__PURE__*/React__default.createElement("div", {
    className: "embed-container-block",
    dangerouslySetInnerHTML: embedHtml
  }) : leadMediaGalleryContent ? leadMediaGalleryContent : undefined), caption && !leadMediaGalleryContent && /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-image-caption",
    className: "mt-[8px] flex flex-col self-stretch font-sans text-p-14 font-normal leading-6 text-[#757575]"
  }, /*#__PURE__*/React__default.createElement("figcaption", {
    "automation-id": "article-caption",
    id: "article-caption",
    dangerouslySetInnerHTML: captionHtml
  })));
};

export { ArticleLeadMedia };
//# sourceMappingURL=article-lead-media.esm.js.map
